import { modelRequest } from '@stem-sims/nexus'
import { ZipcodeResponse } from '../types/accountTypes'

export function get(zipcode: string): Promise<ZipcodeResponse> {
   return modelRequest.get("/api/zipcode?zipcode=" + zipcode)
}
